import React from "react";
import './Success.scss'
import BaseButton from "../BaseButton/BaseButton";
import BottomSheet from "../BottomSheet/BottomSheet";
import {useTranslation} from "react-i18next";

interface Props {
    show: boolean,
    close?: () => void
    title: string,
    subTitle?: string,
    icone: string,
    btnTxt?: string
}

const Success: React.FC<Props> = ({show, close, title, subTitle, icone, btnTxt}: Props) => {
    const {t} = useTranslation('common')
    return (
        <BottomSheet show={show} close={() => close ? close() : {}}>
            <div className="success">
                <img className="success--img" src={icone} alt={t('alt.successIcon')} />
                <p className="success--title">{title}</p>
                {subTitle && <p className="success--subTitle">{subTitle}</p>}
                {
                    close && <BaseButton onClick={close} text={btnTxt || t('actions.continue')} className="success--btn"/>
                }
            </div>
        </BottomSheet>
    )
}

export default Success
